import { useMutation } from '@tanstack/react-query';
import { API } from 'network/api';

const importSalesOrder = async (salesOrderId: string, country: string) => {
  try {
    const res = await API.post(
      `/sales-orders/${salesOrderId}/process?country=${country}&sendNotification=false`,
    );

    return res?.data;
  } catch (error) {
    if (error instanceof Error) throw new Error(error?.message);
    throw new Error('Something went wrong');
  }
};

const useImportSalesOrderMutation = ({
  onSettled,
}: {
  onSettled?: (
    data: Record<string, unknown> | undefined,
    error: Error | null,
    variables: { salesOrderId: string; country: string },
  ) => void;
}) => {
  return useMutation({
    mutationFn: ({
      salesOrderId,
      country,
    }: {
      salesOrderId: string;
      country: string;
    }) => importSalesOrder(salesOrderId, country),
    retry: 1,
    onSettled,
  });
};

export default useImportSalesOrderMutation;
